<template>
    <li class="promotion-active-item" @click="toDetail(itemP)">
        <div class="item-top">
            <template v-for="(pic,index) in itemP.picMap.picActiveList" v-if="index<=0">
                <img :src="pic">
            </template>
        </div>
        <div class="item-bottom">
            <template v-if="flag=='milkKill'||flag=='coffKill'">
                <h3>{{itemP.activeName}}</h3>
            </template>
            <template v-else-if="flag=='secondKill'">
                <h3>已有<span>{{personCount}}</span>人预约</h3>
            </template>
            <template v-else>
                <h3>{{flagList[flag].timeTxt}}
                    <b v-if="itemP.day>0"><i>{{itemP.day}}</i>天</b><span>{{itemP.hour}}</span>时<span>{{itemP.minute}}</span>分<b v-if="itemP.day<=0"><i>{{itemP.second}}</i>秒</b>
                </h3>
            </template>
            <div class="btn-wrap">
                <button class="buy-btn" >{{itemP.seconds>0?flagList[flag].btnText:'已结束'}}<i class="icon iconfont icon-jiantouyou"></i></button>
            </div>
        </div>
    </li>
</template>

<script>
    import {isUserLogin,getPlatformId} from '@/resource/js/GLOBAL2'

    export default{
        data(){
            return {
                personCount:0,
                flagTitle:'',
                flagList:{
                    'secondKill':{
                        title:'预约活动',
                        className:'second-title',
                        btnText:'马上预约',
                        timeTxt:'距离活动结束还有'
                    },
                    'groupKill':{
                        title:'团购优惠',
                        className:'group-title',
                        btnText:'马上参与',
                        timeTxt:'距离团购结束还有'
                    },
                    'chipsKill':{
                        title:'新品投票',
                        className:'chips-title',
                        btnText:'马上参与',
                        timeTxt:''
                    },
                    'activeKill':{
                        title:'限时活动',
                        className:'group-title',
                        btnText:'马上参与',
                        timeTxt:'距离活动结束还有'
                    },
                    'milkKill':{
                        title:'奶卡活动',
                        className:'group-title',
                        btnText:'马上参与',
                        timeTxt:'距离活动结束还有'
                    },
                    'coffKill':{
                        title:'咖啡卡活动',
                        className:'group-title',
                        btnText:'马上参与',
                        timeTxt:'距离活动结束还有'
                    }
                }
            }
        },
        props:['cartData','itemP','vipLevel','vipDay','flag'],
        components:{
        },
        mounted(){
            if(isUserLogin()==1&&this.flag=='secondKill'){
                this.initSencondKill(this.itemP.bindCode)
            }
            if(this.flag=='groupKill'||this.flag=='activeKill'){
                this.$set(this.itemP,'day',0);
                this.countDown(this.itemP)
            }

        },
        methods:{
            initSencondKill(activeNo){
                invokeApi('reserve/getReserveCount',{alias:activeNo},'get',Math.random(),(res)=> {
                        this.personCount = res
                });
            },
            countDown(item){
                let seconds = item.seconds;

                let int = window.setInterval(()=> {
                    let day = Math.floor(seconds / (24*3600))
                    let hour = Math.floor((seconds - day*24*3600)/ 3600);
                    let minute = Math.floor((seconds - day*24*3600-hour * 3600) / 60);
                    let second = Math.floor(seconds - day*24*3600-hour * 3600 - minute * 60);
                    if (seconds <= 0) {
                        clearInterval(int);
                        day = 0;
                        hour = 0;
                        minute = 0;
                        second = 0;

                    } else {
                        seconds--;

                    }
                    this.$set(item,'seconds',seconds);
                    this.$set(item,'day',day);
                    this.$set(item,'hour',zeroTime(hour));
                    this.$set(item,'minute',zeroTime(minute));
                    this.$set(item,'second',zeroTime(second));

                }, 1000);
                function zeroTime(item) {//时间显示处理
                    return parseInt(item) < 10 ? '0' + item : item;
                }
            },
            toDetail(item){
                if(item.seconds>0){
                    window.location.href = item.url
                }
            }
        }

    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    @import "css/promotion.scss";

</style>


// WEBPACK FOOTER //
// src/components/module_pro/active.vue